import {useRef, useState} from 'react';

import {useHasScrolledPastEl} from './use-has-scrolled-past-el';

type UseCoreEntityScrollCheckpointOptions = {
    offset?: number;
};

/**
 * Orchestrates scroll container and action bar ref wiring for core entity pages.
 * Handles element state, checkpoint scroll detection, and top offset calculation.
 */
export function useCoreEntityScrollCheckpoint(options: UseCoreEntityScrollCheckpointOptions = {}) {
    const {offset = -100} = options;
    const scrollContainerRef = useRef<HTMLDivElement | null>(null);
    const actionBarContainerRef = useRef<HTMLDivElement | null>(null);
    const [scrollContainerEl, setScrollContainerEl] = useState<HTMLDivElement | null>(null);
    const [actionBarContainerEl, setActionBarContainerEl] = useState<HTMLDivElement | null>(null);

    const hasScrolledPastCheckpoint = useHasScrolledPastEl({
        scrollContainerEl: scrollContainerEl,
        targetEl: actionBarContainerEl,
        offset,
    });

    const scrollContainerTop = scrollContainerEl
        ? scrollContainerEl.getBoundingClientRect().top
        : 0;

    return {
        hasScrolledPastCheckpoint,
        scrollContainerTop,
        scrollContainerEl,
        setScrollContainerRef: (ref: HTMLDivElement | null) => {
            scrollContainerRef.current = ref;
            setScrollContainerEl(ref);
        },
        setActionBarRef: (ref: HTMLDivElement | null) => {
            actionBarContainerRef.current = ref;
            setActionBarContainerEl(ref);
        },
    };
}
